import { render } from "./drainage-tab.vue?vue&type=template&id=036d67a7"
import script from "./drainage-tab.vue?vue&type=script&lang=js"
export * from "./drainage-tab.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__